import React, { lazy } from 'react';

const sliceComponents = {
  block_blogs: lazy(() => import('./slices/BlockBlogsSlice')),
  block_carousel: lazy(() => import('./slices/BlockCarouselSlice')),
  block_compare: lazy(() => import('./slices/BlockCompareSlice')),
  block_compare_alt: lazy(() => import('./BlockCompareAltSlice')),
  block_contact: lazy(() => import('./slices/BlockContactSlice')),
  block_cta_alt: lazy(() => import('./BlockCTAAltSlice')),
  block_cta_button: lazy(() => import('./BlockCTAButtonSlice')),
  block_case_study_content: lazy(() => import('./BlockCaseStudyContentSlice')),
  block_case_study_hero: lazy(() => import('./slices/BlockCaseStudyHeroSlice')),
  block_case_study_videos: lazy(() => import('./BlockCaseStudyVideosSlice')),
  block_compare_overview: lazy(
    () => import('./slices/BlockCompareOverviewSlice')
  ),
  block_compare_table: lazy(() => import('./slices/BlockCompareTableSlice')),
  block_comparison_image: lazy(() => import('./BlockComparisonImageSlice')),
  block_editorial: lazy(() => import('./BlockEditorialSlice')),
  block_entities_form: lazy(() => import('./slices/BlockEntitiesFormSlice')),
  block_facility_diagram: lazy(
    () => import('./slices/BlockFacilityDiagramSlice')
  ),
  block_facility_map: lazy(() => import('./slices/BlockFacilityMapSlice')),
  block_faqs: lazy(() => import('./slices/BlockFAQsSlice')),
  block_features: lazy(() => import('./slices/BlockFeaturesSlice')),
  block_footer_cta: lazy(() => import('./slices/BlockFooterCTASlice')),
  block_four_up: lazy(() => import('./slices/BlockFourUpSlice')),
  block_four_up_text: lazy(() => import('./slices/BlockFourUpTextSlice')),
  block_four_up_team: lazy(() => import('./slices/BlockFourUpTeamSlice')),
  block_hero_download: lazy(() => import('./BlockHeroDownloadSlice')),
  block_hero_form: lazy(() => import('./slices/BlockHeroFormSlice')),
  block_hero_growth: lazy(() => import('./BlockHeroGrowth')),
  block_hero_photo_left: lazy(() => import('./BlockHeroPhotoLeftSlice')),
  block_hero_photo_right: lazy(() => import('./BlockHeroPhotoRightSlice')),
  block_hero_text_alt: lazy(() => import('./BlockHeroTextAltSlice')),
  block_hero_text: lazy(() => import('./BlockHeroTextSlice')),
  block_hero_typeform: lazy(() => import('./BlockHeroTypeformSlice')),
  block_hero_video: lazy(() => import('./slices/BlockHeroVideoSlice')),
  block_locations_promo: lazy(() => import('./BlockLocationsPromoSlice')),
  block_logo_stripe: lazy(() => import('./slices/BlockLogoStripeSlice')),
  block_kitchen_types: lazy(() => import('./slices/BlockKitchenTypes')),
  block_icon_list: lazy(() => import('./slices/BlockIconListSlice')),
  block_links: lazy(() => import('./BlockLinksSlice')),
  block_other_locations: lazy(() => import('./BlockOtherLocationsSlice')),
  block_nearby_city_locations: lazy(
    () => import('./BlockNearbyCityLocationsSlice')
  ),
  block_overview: lazy(() => import('./BlockOverviewSlice')),
  block_partners: lazy(() => import('./BlockPartnersSlice')),
  block_press: lazy(() => import('./slices/BlockPressSlice')),
  block_press_content: lazy(() => import('./slices/BlockPressContent')),
  block_resources: lazy(() => import('./BlockResourcesSlice')),
  block_six_up: lazy(() => import('./slices/BlockSixUpSlice')),
  block_six_up_alt: lazy(() => import('./BlockSixUpAltSlice')),
  block_specs: lazy(() => import('./slices/BlockSpecsSlice')),
  block_strategic_locations: lazy(
    () => import('./slices/BlockStrategicLocationsSlice')
  ),
  block_team_slice: lazy(() => import('./slices/BlockTeamSlice')),
  block_technology: lazy(() => import('./slices/BlockTechnologySlice')),
  block_testimonials_slider_alt: lazy(
    () => import('./BlockTestimonialsSliderAltSlice')
  ),
  block_testimonials_text: lazy(
    () => import('./slices/BlockTestimonialsTextSlice')
  ),
  block_testimonials_video: lazy(
    () => import('./slices/BlockTestimonialsVideoSlice')
  ),
  block_three_up: lazy(() => import('./BlockThreeUpSlice')),
  block_value_props: lazy(() => import('./slices/BlockValuePropsSlice')),
  block_video: lazy(() => import('./slices/BlockVideoSlice')),
  block_find_your_ghost_kitchen: lazy(
    () => import('./slices/BlockFindYourGhostKitchen')
  ),
  block_legal_text: lazy(() => import('./slices/BlockLegalTextSlice')),
  block_kitchen_layout: lazy(() => import('./slices/BlockKitchenLayout')),
  block_photo_left: lazy(() => import('./slices/BlockPhotoLeft')),
  block_photo_full_bleed: lazy(() => import('./slices/BlockPhotoFullBleed')),
  block_photo_container: lazy(() => import('./slices/BlockPhotoContainer')),
  block_virtual_brands: lazy(() => import('./slices/BlockVirtualBrands')),
  block_pdf: lazy(() => import('./slices/BlockPDF')),
  block_entities_locations: lazy(
    () => import('./slices/BlockEntitiesLocations')
  ),
  block_scrollable: lazy(() => import('./slices/BlockScrollable')),
  block_divider: lazy(() => import('./slices/BlockDivider')),
  block_stats_banner: lazy(() => import('./slices/BlockStatsBanner')),
  block_tabbed_photo_module: lazy(
    () => import('./slices/BlockTabbedPhotoModuleSlice')
  ),
  block_youtube_embed: lazy(() => import('./slices/BlockYoutubeEmbedSlice')),
  block_404: lazy(() => import('./slices/Block404')),
  block_enterprise_kitchens: lazy(
    () => import('./slices/BlockEnterpriseKitchens')
  ),
  block_restaurant_tech: lazy(() => import('./slices/BlockRestaurantTech')),
  block_facility_type: lazy(() => import('./slices/BlockFacilityType')),
  block_facility_companies: lazy(
    () => import('./slices/BlockFacilityCompanies')
  ),
};

// PN: These slices rely on static queries so I'm disabling them outside of CK for now
const ckOnlySlices = [
  'block_blogs',
  'block_compare',
  'block_customers_blog',
  'block_cta_alt',
  'block_press',
  'block_team_slice',
];

const SliceZone = ({
  slices,
  slug,
  pageContext: { siteTag, siteURL },
  location,
}) => {
  const sliceZoneContent = slices.map((slice, index) => {
    if (
      siteTag !== 'site:cloudkitchens' &&
      ckOnlySlices.includes(slice.slice_type)
    ) {
      console.warn('Skipping slice: ', slice.slice_type);
      return null;
    }

    if (slice) {
      const SliceComponent = sliceComponents[slice.slice_type];
      if (SliceComponent) {
        return (
          <SliceComponent
            key={index}
            slice={slice}
            sliceIndex={index}
            slug={slug}
            siteURL={siteURL}
            location={location}
          />
        );
      }
    }
    return null;
  });

  return sliceZoneContent;
};

export default SliceZone;
